import { ArrowBackIcon } from "@chakra-ui/icons";

import { RanaButton } from "@nens/ranalib";

export function PublicationMapBackButton({ onClick }: { onClick: () => void }) {
  return (
    <RanaButton
      h="button"
      w="button"
      variant="fourthiary"
      display="flex"
      alignItems="center"
      justifyContent="center"
      onClick={onClick}
      borderWidth="base"
      borderColor="brand.glacier"
    >
      <ArrowBackIcon boxSize={6} />
    </RanaButton>
  );
}
